import { useQuery } from "@apollo/client";
import { WebUserProvider } from "contexts";
import { GET_ME_QUERY, GetMeOutput } from "graphql/webuser";
import LoadingPage from "pages/LoadingPage";
import { ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { GA_USER_TYPE_DIMENSION, getGAUserType, setCustomDimension } from "services/googleAnalytics";

export type ProtectedRouteProps = {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps): JSX.Element => {
  const { data, error, loading } = useQuery<GetMeOutput>(GET_ME_QUERY);

  const redirectToLoginPage = (response : Response) => {
    const location = response?.headers?.get('Location');
    if (location !== window.location.href) {
      window.location.replace(location);
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  if (
    error &&
    'statusCode' in error.networkError &&
    error.networkError?.statusCode === 401 &&
    error.networkError?.response?.headers?.has('Location')
  ) {
    redirectToLoginPage(error.networkError?.response);
    return;
  }

  const webUser = data?.me?.user;
  if (!webUser) {
    return <FormattedMessage id="error.userNotFound" />;
  }

  
  setCustomDimension(GA_USER_TYPE_DIMENSION, getGAUserType(webUser));
  return <WebUserProvider value={{ webUser }}>{ children }</WebUserProvider>;
}

export default ProtectedRoute;